// In production (Vercel), REACT_APP_API_URL points to the Railway backend.
// In development (localhost), it's empty so the CRA proxy handles it.
const API_BASE = process.env.REACT_APP_API_URL || '';

export const apiUrl = (path) => `${API_BASE}${path}`;
